import { css } from '@styled-system/css';
import { type FC, useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { ProductFeed } from '@/shared/components/product/ProductFeed';
import { Message } from '@/shared/components/ui/Message';

import { useProductsByStatus } from '../hooks/useProductsByStatus';

import { SELL_HISTORY_TAB_STATUS_MAPPING, type SellHistoryTabValue } from '../types';
import { SellHistoryTabs } from './SellHistoryTabs';

export const AnalysisPageSellsHist: FC = () => {
  const { id: analysisId } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<SellHistoryTabValue>('sold');

  // Récupération des produits du backend
  const {
    allProducts,
    isLoading: productsLoading,
    error: productsError,
  } = useProductsByStatus({
    analysisId: analysisId ?? '',
    status: SELL_HISTORY_TAB_STATUS_MAPPING[activeTab],
    enabled: !!analysisId,
  });

  const containerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: 'xs',
  });

  const handleTabChange = useCallback((tab: SellHistoryTabValue) => {
    setActiveTab(tab);
  }, []);

  if (!analysisId) {
    return (
      <div className={containerStyles}>
        <Message type="error" bordered>
          ID d'analyse manquant
        </Message>
      </div>
    );
  }

  if (productsError) {
    return (
      <div className={containerStyles}>
        <Message type="error" bordered>
          {productsError}
        </Message>
      </div>
    );
  }

  return (
    <div className={containerStyles}>
      {/* Tabs */}
      <SellHistoryTabs activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Product Feed */}
      <ProductFeed
        allProducts={allProducts}
        status={SELL_HISTORY_TAB_STATUS_MAPPING[activeTab]}
        isLoading={productsLoading}
      />
    </div>
  );
};
